import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['emailInput', 'modal'];
  static values = { autoOpen: Boolean };

  connect() {
    this.modal = new bootstrap.Modal(this.modalTarget);
    this.modalTarget.addEventListener(
      'shown.bs.modal',
      this.focusInput.bind(this)
    );

    if (this.autoOpenValue) this.openModal();
  }

  openModal() {
    this.modal.show();
  }

  focusInput() {
    this.emailInputTarget.focus();
  }
}
